import './styles/TopNavStyle.css';
import { useState } from 'react';
import { ReactComponent as DHLLogo } from '../../resources/images/dhl_logo.svg';
import { useTypedSelector } from '../../hooks/useTypedSelector';
import { useActions } from '../../hooks/useActions';
import { languageMap } from '../../maps/languageMap';
import { Modal, Button } from 'react-bootstrap';
import { RiComputerFill, RiInformationFill } from 'react-icons/ri';
import { GrPowerReset } from 'react-icons/gr';

interface TopNavProps {
  logoNavigation?(): void;
  dataCyPrefix: string;
}
const TopNav: React.FC<TopNavProps> = ({ logoNavigation, dataCyPrefix }) => {
  const [showKioskInfoModal, setShowKioskInfoModal] = useState(false);
  const { sessionExitShowModal } = useActions();
  const installationId = useTypedSelector((state) => {
    return state.kioskData.installation.id;
  });
  const language = useTypedSelector((state) => {
    return state.session.language;
  });
  const getTopNavColor = () => {
    if (process.env.REACT_APP_API_ENV === 'PROD') {
      return 'top-nav-prod';
    }
    if (process.env.REACT_APP_API_ENV === 'QA') {
      return 'top-nav-qa';
    }
    return 'top-nav-dev';
  };
  const doubleClickLogo = () => {
    if (logoNavigation) {
      logoNavigation();
    }
    return;
  };
  const renderkioskInfoModal = () => {
    return (
      <Modal
        className="kiosk-details-modal"
        show={showKioskInfoModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="kiosk-details-modal-container">
            <div className="kiosk-details-row-modal">
              <p className="kiosk-details-text-modal">
                <b>{languageMap.top_nav.environment[language]}: </b>
                {`${process.env.REACT_APP_API_ENV}`}
              </p>
              <p className="kiosk-details-text-modal">
                <b>{languageMap.top_nav.installation[language]}: </b>
                {`${installationId}`}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => setShowKioskInfoModal(false)}
            variant="success"
          >
            {languageMap.top_nav.kiosk_info_modal_button[language]}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  return (
    <div id="topNav" className="top-nav-container">
      <div className={getTopNavColor()} />
      {renderkioskInfoModal()}
      <DHLLogo
        onDoubleClick={() => doubleClickLogo()}
        className="top-dhl-logo"
      />
      <div className="kiosk-details-column">
        <div
          className="kiosk-details-icon-container"
          onClick={() => setShowKioskInfoModal(true)}
        >
          <RiComputerFill className="kiosk-details-icon" />
          <RiInformationFill className="kiosk-details-icon-info" />
        </div>
        <div className="kiosk-details-row">
          <p className="kiosk-details-text">
            <b>{languageMap.top_nav.environment[language]}: </b>
            {`${process.env.REACT_APP_API_ENV}`}
          </p>
          <p className="kiosk-details-text">
            <b>{languageMap.top_nav.installation[language]}: </b>
            {`${installationId}`}
          </p>
        </div>
      </div>
      <div className="top-nav-button-container">
        <div className="top-nav-button-box">
          <div className="top-nav-button">
            <button
              onClick={() => {
                console.log('Show');
                sessionExitShowModal(true);
              }}
              className="exit-button"
            >
              <div className="exit-icon-container">
                <GrPowerReset className="exit-icon" />
              </div>
            </button>
          </div>
        </div>
        <div className="top-nav-button-box"></div>
      </div>
    </div>
  );
};

export { TopNav };
